// Same rule the gateway uses (src/auth/guardian.ts there): whole years on
// today's UTC date. The form uses it only to know whether to ask for a
// parent's or guardian's email; the gateway decides.
export const ADULT_AGE = 18;

export function ageOn(y: number, m: number, d: number, today = new Date()): number {
  const ty = today.getUTCFullYear(), tm = today.getUTCMonth() + 1, td = today.getUTCDate();
  return ty - y - (tm < m || (tm === m && td < d) ? 1 : 0);
}

/** True when the day exists in that month and year (no 31 April, no 29 February 2009). */
export function realDate(y: number, m: number, d: number): boolean {
  const date = new Date(Date.UTC(y, m - 1, d));
  return date.getUTCFullYear() === y && date.getUTCMonth() === m - 1 && date.getUTCDate() === d;
}

export function isoDate(y: number, m: number, d: number): string {
  return `${String(y).padStart(4, '0')}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}
